module.exports = __webpack_public_path__ + "static/media/HighCost_02.e1347928.svg";